import { WSForm, WSInputNumber } from "@wingspanhq/fe-component-library";
import { IAttributeDefinition } from "@wingspanhq/payments/dist/interfaces";

type Props = {
  definition: IAttributeDefinition;
};

export const FieldNumber: React.FC<Props> = props => {
  return (
    <WSForm.Field
      name={props.definition.key}
      component={WSInputNumber}
      componentProps={{
        label: props.definition.name,
        helperText: props.definition.description,
        required: props.definition.required,
        min: props.definition.validationRules?.minimum,
        max: props.definition.validationRules?.maximum,
        maxFractionDigits: 2
      }}
    />
  );
};
